import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import Navbar from "../Navbar";
import Footer from "../Footer";
import EmployeeSidebar from "../EmployeeSidebar";

const EmployeeLayout = ({ children }) => {
    const { user } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    // Check if device is mobile
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768); // md breakpoint
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Set initial sidebar state based on device
    useEffect(() => {
        if (isMobile) {
            setSidebarOpen(false); // Hidden on mobile by default
        } else {
            setSidebarOpen(true); // Visible on desktop by default
        }
    }, [isMobile]);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    if (user) {
        return (
            <div className="flex h-screen bg-gray-100">
                {/* Desktop Sidebar - always visible on desktop */}
                {!isMobile && (
                    <div className="block">
                        <EmployeeSidebar isOpen={sidebarOpen} onToggle={toggleSidebar} isMobile={isMobile} />
                    </div>
                )}
                
                {/* Mobile Sidebar Overlay */}
                {isMobile && sidebarOpen && (
                    <>
                        {/* Backdrop */}
                        <div 
                            className="fixed inset-0 bg-black bg-opacity-50 z-40"
                            onClick={toggleSidebar}
                        />
                        {/* Sidebar */}
                        <div className="fixed left-0 top-0 h-full z-50">
                            <EmployeeSidebar isOpen={sidebarOpen} onToggle={toggleSidebar} isMobile={isMobile} />
                        </div>
                    </>
                )}
                
                <div className="flex-1 flex flex-col overflow-hidden">
                    <Navbar 
                        onToggleSidebar={toggleSidebar} 
                        sidebarOpen={sidebarOpen}
                        isMobile={isMobile}
                    />
                    <main className="flex-1 overflow-x-hidden overflow-y-auto p-6">
                        {children}
                    </main>
                </div>
            </div>
        );
    }

    return (
        <>
            <Navbar />
            {children}
            <Footer />
        </>
    );
};

export default EmployeeLayout;
